import { Outlet } from "react-router-dom";
import { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import UpgradeBanner from "./UpgradeBanner";
import ImpersonationBanner from "./ImpersonationBanner";
import PlanAccessGuard from "./PlanAccessGuard";
import { Sprints360Provider } from "@/context/Sprints360Context";
import { S360ConsultProvider } from "@/context/S360ConsultContext";

export default function AppLayout() {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    // Sprints360Provider hoisted at layout level para que projetos criados em
    // /app/projetos persistam ao abrir /app/sprints360/:id (single-tenant).
    // S360ConsultProvider — Phase 11.0: plano CONSULTORIA (multi-empresa).
    // PlanAccessGuard — Phase 12.30: bloqueia rotas sem plano contratado +
    // status workspace suspenso/cancelado.
    <S360ConsultProvider>
    <Sprints360Provider>
      <PlanAccessGuard>
        <div className="min-h-screen flex bg-slate-50">
          <Sidebar mobileOpen={mobileSidebarOpen} onMobileOpenChange={setMobileSidebarOpen} />
          <div className="flex-1 min-w-0 flex flex-col">
            <Header onMenuClick={() => setMobileSidebarOpen(true)} />
            <ImpersonationBanner />
            <UpgradeBanner />
            <main className="flex-1 p-4 sm:p-6 lg:p-8" data-testid="app-main">
              <Outlet />
            </main>
          </div>
        </div>
      </PlanAccessGuard>
    </Sprints360Provider>
    </S360ConsultProvider>
  );
}
